import React from "react";
import WebData from "../../../../Helpers/WebData";
import ReactMarkdown from "react-markdown";
import "./CSRGiving.style.css";

const CSRGiving = () => {
  const paragraph =
    "Your donations expand human welfare by A. raising awareness of organic farming, B. helping rural economy connect to the cities, C. contributing to local cattle breed conservation and, D. raising awareness of economic and environmental benefits of conservation.\n\nYou get to choose the projects you want delivered. Your donations are eligible for exemptions u/s 80(G).";
  const pa = paragraph + paragraph + paragraph;
  return (
    <>
      <section id="csrGivingTab">
        <div className="row mx-0 mx-lg-3 mx-md-0 justify-content-left">
          <div className="engage-container scrollbar-hide">
            <p className="justify-desc">
              <ReactMarkdown>{pa}</ReactMarkdown>
            </p>
            <p>
              <a
                data-toggle="pill"
                href="#v-pills-gift"
                role="tab"
                aria-controls="v-pills-gift"
                aria-selected="true"
                onClick={() => {
                  document
                    .getElementById("v-pills-csr-tab")
                    .classList.remove("active");
                  document
                    .getElementById("v-pills-gift-tab")
                    .classList.add("active");
                  document.getElementById("v-pills-gift-tab").click();
                }}
              >
                Click here
              </a>{" "}
              for gifting merchandise or promotional products.{" "}
              <a
                id="v-pills-donate-tab"
                data-toggle="pill"
                href="#v-pills-donate"
                role="tab"
                aria-controls="v-pills-donate"
                aria-selected="true"
                onClick={() => {
                  document
                    .getElementById("v-pills-csr-tab")
                    .classList.remove("active");
                  document
                    .getElementById("v-pills-donate-tab")
                    .classList.add("active");
                  document.getElementById("v-pills-donate-tab").click();
                }}
              >
                Click here
              </a>{" "}
              for donating money.
            </p>
            <p>
              {"Please talk to us here "}
              <a
                className="me-1 ms-3"
                target="_blank"
                rel="noopener noreferrer"
                href={`tel:${WebData.contact.phone}`}
              >
                <i className="ml-3 mr-1 fa fa-phone"></i>
              </a>
              <a
                target="_blank"
                className="mx-1"
                rel="noopener noreferrer"
                href={`https://wa.me/${WebData.contact.whatsapp}`}
              >
                <i className="mx-1 fa fa-whatsapp"></i>
              </a>
              <a
                target="_blank"
                className="mx-1"
                rel="noopener noreferrer"
                href={`https://telegram.me/${WebData.contact.telegram}`}
              >
                <i className="mx-1 fa fa-telegram"></i>
              </a>
              <a
                target="_blank"
                className="mx-1"
                rel="noopener noreferrer"
                href={`mailto:${WebData.contact.mail}`}
              >
                <i className="mx-1 fa fa-envelope"></i>
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default CSRGiving;
